export function caseInsensitiveCompare(str1, str2) {
    return str1.toLowerCase() === str2.toLowerCase();
}
